'use strict';

var _advancedFetch = require('./advanced-fetch');

var _advancedFetch2 = _interopRequireDefault(_advancedFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.globalUtils = {
    resetAndGoToHome: function resetAndGoToHome() {
        fetch('/api/reset', {
            credentials: 'include',
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' }
        }).then(_advancedFetch2.default.checkStatus).then(function (response) {
            window.location = '/';
        }).catch(function (err) {
            void 0;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./client/global-utils.js
// module id = 431
// module chunks = 0